import React from "react";
import UserRolesContext from "../../context/userRolesContext";

const WithUserRoles = Component => {
  return class extends React.Component {
    render() {
      return (
        <UserRolesContext.Consumer>
          {userRoles => <Component userRoles={userRoles} {...this.props} />}
        </UserRolesContext.Consumer>
      );
    }
  };
};

export default WithUserRoles;
